import {
  FlexProps,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { noop } from "@chakra-ui/utils";
import React from "react";
import { Messages } from "../../core/api";
import useCallCenter from "../../modules/call-center/hooks/useCallCenter";
import DialerTabs, { DialerTabsContext } from "../../modules/communication/components/DialerTabs";

interface Props {
  isOpen: boolean;
  predefinedPhoneNumber?: string;
  onClose: () => void;
}

export default function DialerModal({ isOpen, predefinedPhoneNumber, onClose }: Props) {
  const callCenter = useCallCenter();

  React.useEffect(() => {
    if (callCenter.state.status === "Active") {
      onClose();
    }
  }, [callCenter.state.status, onClose]);

  const handleDial = (
    invitee: Messages["TelephonyUnResolvedInviteToCallInvitee"] & {
      phonenumber: string;
    }
  ) => {
    switch (invitee.type) {
      case "AgencyMember":
        break;

      case "Patient":
      case "Caregiver":
      case "NotIdentified":
      case "PatientContact":
      case "PhonebookContact":
        callCenter.dial({ destination: invitee.phonenumber });
        break;

      case "BotAgent":
        callCenter.dial({ destination: invitee.phonenumber, botAgent: invitee.botAgent });
    }
  };

  return (
    <Modal isOpen={isOpen} size="lg" onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>Make a call</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <DialerTabs
            context={dialerTabsContext}
            flexProps={dialerFlexProps}
            isCalling={callCenter.state.status === "Dialing"}
            predefinedPhoneNumber={predefinedPhoneNumber}
            onClickAgencyMember={noop}
            onClickDial={handleDial}
          />
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
}

const dialerTabsContext: DialerTabsContext = {
  hideAgencyMembers: true,
  hideCaregivers: false,
  hidePatients: false,
  hidePhoneNumber: false,
  hidePhonebook: false,
  hideBotAgents: false,
};

const dialerFlexProps: FlexProps = {
  flex: "1",
  alignItems: "center",
  mt: 10,
};
